import Vue from 'vue'

export default {
  createPromo({ promo }) {
    return Vue.http.post(`app-services/v2/promos/`, promo)
  },
  updatePromo({ promoId, promo }) {
    return Vue.http.put(`app-services/v2/promos/${promoId}`, promo)
  },
  getPromo({ promoId }) {
    return Vue.http.get(`app-services/v2/promos/${promoId}`)
  },
  listPromos({ filters, select }) {
    return Vue.http.post(`app-services/v2/promos/list`, { filters, select })
  },
  deletePromo({ promoId }) {
    return Vue.http.delete(`app-services/v2/promos/${promoId}`)
  },
  usedCode({ customerId, promoId, redemptionTimestamp }) {
    return Vue.http.post(`app-services/v2/promos/used-code`, {
      customerId,
      promoId,
      redemptionTimestamp
    })
  }
}
